/** имя проекта. Разные имена могут быть в одном и том же пространстве переводов */
export type LangProjectName = 'vk' | 'ok';
export type LangConfig = ReturnType<typeof getLangConfig>;

/** Конфиг загрузки переводов vkui-lang-config.json */
export interface LangFileConfig {
  /** префикс переводов */
  defaultNsPrefix: string;
  /** ключи языков, через запятую */
  langs: string;
  /** имя секции, по которой будет производится поиск */
  name: string;
  /** путь, относительно файла vkui-lang-config.json куда будут сохраняться фолбеки переводы */
  dist: string;
  /** параметр нужен для загрузки файлов переводов, в рантайме не нужен */
  force?: string;
}

export function getLangConfig(args: {
  /** конфиг из файла vkui-lang-config.json */
  config: LangFileConfig;
  /** Входящий код языка. Может получаться из launchParams */
  inputLang?: string;
  defaultLang?: string;
  /** синонимы языков. Для того чтобы по разным языковым кодам отдавать нужные переводы */
  aliases?: { [key: string]: string };
  vkExperiments?: string;
}) {
  const { config, inputLang, defaultLang = 'ru', aliases, vkExperiments } = args;
  const { langs, name, defaultNsPrefix } = config;
  const langsArr = langs.split(',');
  const lang = inputLang ? aliases?.[inputLang] || inputLang : defaultLang;
  const supportedLang = isSupportedLanguage(lang, langsArr) ? lang : defaultLang;

  return { lang: supportedLang, name, prefix: defaultNsPrefix, vkExperiments };
}

function isSupportedLanguage<T>(language: string, supportedLanguages: readonly T[]): language is Extract<T, string> {
  return supportedLanguages.includes(language as T);
}

/** @return example: https://vk.com/js/lang-pack.js?name=lovina&lang=ru&format=json  */
export const getLangFileUrl = (params: { name: string; lang: string; origin: string }) => {
  return `${params.origin}/js/lang-pack.js?name=${params.name}&lang=${params.lang}&format=json`;
};

export function getLangDatingFileUrl(apiHttpUrl: string, lang: string, rawExperiments: string) {
  return `${apiHttpUrl}/config.langPack?lang=${lang}&vk_experiment=${rawExperiments}`;
}

/**
 * Получение языка из параметров запуска (ru, kz и т.д.)
 */
export const getLangFromLaunchParams = (launchParams: string) => {
  return new RegExp('vk_language=([a-z]+)').exec(launchParams)?.[1] || 'ru';
};
